import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { mergedEnTranslations } from 'Locales/merged-en'
import { mergedEsTranslations } from 'Locales/merged-es'
import { LANGUAGES_OPTIONS } from 'Types/Languages'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: LANGUAGES_OPTIONS.EN,
    resources: {
      en: mergedEnTranslations,
      es: mergedEsTranslations,
    },
    compatibilityJSON: 'v3',
    interpolation: {
      escapeValue: false,
    },
    lng: LANGUAGES_OPTIONS.EN,
  })

export default i18n
